(() => {
  const moneyFromCents = (cents, currency = 'RON') => new Intl.NumberFormat('ro-RO', {
    style: 'currency', currency, minimumFractionDigits: 2
  }).format(cents / 100);
  const decimalFromCents = (cents) => new Intl.NumberFormat('ro-RO', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  }).format(cents / 100);

  const initCollection = (root) => {
    if (!root || root.dataset.asReady === 'true') return;
    root.dataset.asReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-as-product-card]'));
    const count = root.querySelector('[data-as-count]');
    const empty = root.querySelector('[data-as-empty]');
    let flavor = 'all';
    let volume = 'all';

    const applyFilters = () => {
      let visible = 0;
      cards.forEach((card) => {
        const showFlavor = flavor === 'all' || card.dataset.asFlavor === flavor;
        const showVolume = volume === 'all' || card.dataset.asVolume === volume;
        const show = showFlavor && showVolume;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = `${visible} ${visible === 1 ? 'produs' : 'produse'} pentru selecția curentă`;
      if (empty) empty.hidden = visible !== 0;
    };

    root.querySelectorAll('[data-as-flavor]').forEach((button) => {
      button.addEventListener('click', () => {
        flavor = button.dataset.asFlavor;
        volume = 'all';
        root.querySelectorAll('[data-as-flavor]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-as-volume]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        applyFilters();
      });
    });

    root.querySelectorAll('[data-as-volume]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = button.dataset.asVolume;
        volume = volume === next ? 'all' : next;
        flavor = 'all';
        root.querySelectorAll('[data-as-volume]').forEach((item) => item.setAttribute('aria-pressed', String(item === button && volume !== 'all')));
        root.querySelectorAll('[data-as-flavor]').forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.asFlavor === 'all')));
        applyFilters();
        root.querySelector('[data-as-product-grid]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelector('[data-as-sort]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  };

  const initProduct = (root) => {
    if (!root || root.dataset.asReady === 'true') return;
    root.dataset.asReady = 'true';

    const variantsNode = root.querySelector('[data-as-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent || '[]');
    const select = root.querySelector('[data-as-variant-select]');
    const cartVariant = root.querySelector('[data-as-cart-variant]');
    const getPackOptions = () => Array.from(root.querySelectorAll('[data-as-pack-option]'));
    const getMainPackOption = () => root.querySelector('[data-as-pack-option][data-main-product="true"]');
    const price = root.querySelector('[data-as-product-price]');
    const unitPrice = root.querySelector('[data-as-unit-price]');
    const compare = root.querySelector('[data-as-compare-price]');
    const submit = root.querySelector('[data-as-product-submit]');
    const quantity = root.querySelector('[data-as-quantity]');
    const quantityLabel = root.querySelector('[data-as-quantity-label]');
    const stock = root.querySelector('[data-as-stock]');
    const stockText = root.querySelector('[data-as-stock-text]');
    const progress = root.querySelector('[data-as-shipping-progress]');
    const progressText = root.querySelector('[data-as-shipping-text]');
    const stickyPrice = root.querySelector('[data-as-sticky-price]');
    const stickyTitle = root.querySelector('[data-as-sticky-title]');
    const currency = root.dataset.currency || 'RON';

    const updateUnitPrice = (cents, packSize = 1) => {
      const litersPerBox = Number(unitPrice?.dataset.asUnitLiters || 0);
      const totalLiters = litersPerBox * Math.max(1, Number(packSize || 1));
      if (unitPrice && totalLiters > 0) unitPrice.textContent = `${decimalFromCents(cents / totalLiters)} lei / litru`;
    };

    const updateShippingProgress = (total) => {
      const threshold = Number(root.dataset.shippingThreshold || 20000);
      const remaining = Math.max(0, threshold - total);
      if (progress) progress.style.width = `${Math.min(100, (total / threshold) * 100)}%`;
      if (progressText) progressText.textContent = remaining === 0
        ? 'Ai transport gratuit.'
        : `Mai adaugă produse de ${moneyFromCents(remaining, currency)} pentru transport gratuit.`;
    };

    const currentMainVariant = () => variants.find((item) => String(item.id) === String(select?.value)) || variants[0];

    const syncMainPackOption = (variant) => {
      const mainPackOption = getMainPackOption();
      if (!variant || !mainPackOption) return;
      mainPackOption.dataset.variantId = variant.id;
      mainPackOption.dataset.price = variant.price;
      mainPackOption.dataset.comparePrice = variant.compare_at_price || 0;
      mainPackOption.dataset.available = variant.available;
      mainPackOption.querySelector('.as-pack-option__price strong').textContent = `${decimalFromCents(variant.price)} lei`;
      const optionUnitPrice = mainPackOption.querySelector('[data-as-pack-unit-price]');
      const optionLiters = Number(mainPackOption.dataset.totalLiters || unitPrice?.dataset.asUnitLiters || 0);
      if (optionUnitPrice && optionLiters > 0) {
        optionUnitPrice.textContent = `${decimalFromCents(variant.price / optionLiters)} lei / litru`;
      }
    };

    const updateChoice = (option) => {
      if (!option) return;
      const selectedPrice = Number(option.dataset.price || 0);
      const comparePrice = Number(option.dataset.comparePrice || 0);
      const available = option.dataset.available === 'true';
      const packSize = Math.max(1, Number(option.dataset.packSize || 1));
      const selectedTitle = option.dataset.productTitle || '';

      getPackOptions().forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      if (cartVariant) cartVariant.value = option.dataset.variantId || '';
      if (price) price.textContent = moneyFromCents(selectedPrice, currency);
      updateUnitPrice(selectedPrice, packSize);
      if (stickyPrice) stickyPrice.textContent = moneyFromCents(selectedPrice, currency);
      if (stickyTitle) stickyTitle.textContent = selectedTitle;
      if (compare) {
        compare.textContent = comparePrice > selectedPrice ? moneyFromCents(comparePrice, currency) : '';
        compare.hidden = !(comparePrice > selectedPrice);
      }
      if (submit) {
        submit.disabled = !available;
        submit.querySelector('span').textContent = available
          ? (packSize > 1 ? `Adaugă pachetul de ${packSize} în coș` : 'Adaugă în coș')
          : 'Stoc epuizat';
      }
      if (stock) stock.classList.toggle('as-stock--out', !available);
      if (stockText) stockText.textContent = available ? 'În stoc' : 'Stoc epuizat';
      if (quantityLabel) quantityLabel.textContent = packSize > 1 ? 'Pachete' : 'Cantitate';

      const total = selectedPrice * Math.max(1, Number(quantity?.value || 1));
      updateShippingProgress(total);

    };

    const update = () => {
      const variant = currentMainVariant();
      if (!variant) return;
      const mainPackOption = getMainPackOption();
      syncMainPackOption(variant);
      if (mainPackOption?.getAttribute('aria-pressed') === 'true') {
        updateChoice(mainPackOption);
      } else if (!mainPackOption) {
        const available = Boolean(variant.available);
        if (cartVariant) cartVariant.value = variant.id;
        if (price) price.textContent = moneyFromCents(variant.price, currency);
        updateUnitPrice(Number(variant.price || 0), 1);
        if (stickyPrice) stickyPrice.textContent = moneyFromCents(variant.price, currency);
        if (compare) {
          compare.textContent = variant.compare_at_price > variant.price ? moneyFromCents(variant.compare_at_price, currency) : '';
          compare.hidden = !(variant.compare_at_price > variant.price);
        }
        if (submit) {
          submit.disabled = !available;
          submit.querySelector('span').textContent = available ? 'Adaugă în coș' : 'Stoc epuizat';
        }
        if (stock) stock.classList.toggle('as-stock--out', !available);
        if (stockText) stockText.textContent = available ? 'În stoc' : 'Stoc epuizat';
        updateShippingProgress(Number(variant.price || 0) * Math.max(1, Number(quantity?.value || 1)));
      }

      if (mainPackOption?.getAttribute('aria-pressed') === 'true' && variant.featured_media?.preview_image?.src) {
        root.querySelectorAll('[data-as-main-image]').forEach((image) => {
          image.src = variant.featured_media.preview_image.src;
        });
      }
    };

    select?.addEventListener('change', update);
    quantity?.addEventListener('input', () => {
      const selectedOption = getPackOptions().find((item) => item.getAttribute('aria-pressed') === 'true') || getMainPackOption();
      if (selectedOption) updateChoice(selectedOption);
      else {
        const variant = currentMainVariant();
        if (variant) updateShippingProgress(Number(variant.price || 0) * Math.max(1, Number(quantity?.value || 1)));
      }
    });
    root.addEventListener('click', (event) => {
      const option = event.target instanceof Element ? event.target.closest('[data-as-pack-option]') : null;
      if (option && root.contains(option) && !option.disabled) updateChoice(option);
    });
    root.querySelectorAll('[data-as-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-as-main-image]').forEach((image) => {
          image.src = thumb.dataset.asImage;
          image.alt = thumb.dataset.asAlt || image.alt;
        });
        root.querySelectorAll('[data-as-thumb]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumb)));
      });
    });
    root.querySelector('[data-as-sticky-add]')?.addEventListener('click', () => submit?.click());
    update();
  };

  const initJudgeMeReviews = (root) => {
    if (!root || root.dataset.asReady === 'true') return;
    root.dataset.asReady = 'true';

    const productIds = (root.dataset.productIds || root.dataset.productId || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
    const shopDomain = root.dataset.shopDomain;
    const status = root.querySelector('[data-as-review-status]');
    const grid = root.querySelector('[data-as-review-grid]');
    const summary = root.querySelector('[data-as-review-summary]');
    const actions = root.querySelector('[data-as-review-actions]');
    const moreButton = root.querySelector('[data-as-review-more]');
    if (!productIds.length || !shopDomain || !grid) return;

    const cleanText = (html) => {
      const documentNode = new DOMParser().parseFromString(html || '', 'text/html');
      return documentNode.body.textContent?.trim() || '';
    };

    const renderReview = (review) => {
      const article = document.createElement('article');
      article.className = 'as-review-card';

      const top = document.createElement('div');
      top.className = 'as-review-card__top';
      const stars = document.createElement('span');
      stars.className = 'as-review-card__stars';
      stars.setAttribute('aria-label', `${review.rating} din 5 stele`);
      stars.textContent = '★'.repeat(Math.max(0, Math.min(5, Number(review.rating || 0))));
      const date = document.createElement('time');
      date.dateTime = review.created_at || '';
      date.textContent = review.created_at
        ? new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(review.created_at))
        : '';
      top.append(stars, date);

      const bodyText = cleanText(review.body_html);
      if (review.title) {
        const title = document.createElement('h3');
        title.textContent = review.title;
        article.append(top, title);
      } else {
        article.append(top);
      }
      if (bodyText) {
        const body = document.createElement('p');
        body.textContent = bodyText;
        article.append(body);
      }

      if (review.pictures_urls?.[0]?.small) {
        const picture = document.createElement('img');
        picture.className = 'as-review-card__photo';
        picture.src = review.pictures_urls[0].small;
        picture.alt = `Fotografie adăugată de ${review.reviewer_name || 'client'}`;
        picture.loading = 'lazy';
        article.append(picture);
      }

      if (review.product_title) {
        const productLabel = document.createElement(review.product_url ? 'a' : 'span');
        productLabel.className = 'as-review-card__product';
        productLabel.textContent = `Recenzie pentru: ${review.product_title}`;
        if (review.product_url) productLabel.href = review.product_url;
        article.append(productLabel);
      }

      const author = document.createElement('footer');
      const avatar = document.createElement('span');
      avatar.textContent = review.reviewer_initial || 'A';
      const identity = document.createElement('div');
      const name = document.createElement('strong');
      name.textContent = review.reviewer_name || 'Anonim';
      identity.append(name);
      if (review.verified_buyer) {
        const verified = document.createElement('small');
        verified.textContent = '✓ Achiziție verificată';
        identity.append(verified);
      }
      author.append(avatar, identity);
      article.append(author);
      return article;
    };

    const endpointFor = (productId, page) => {
      const endpoint = new URL('https://api.judge.me/reviews/reviews_for_widget');
      endpoint.search = new URLSearchParams({
        product_id: productId,
        page: String(page),
        per_page: '100',
        shop_domain: shopDomain,
        platform: 'shopify'
      }).toString();
      return endpoint.toString();
    };

    const fetchPage = (productId, page) => fetch(endpointFor(productId, page))
      .then((response) => {
        if (!response.ok) throw new Error('Judge.me response error');
        return response.json();
      });

    const fetchProductReviews = (productId) => fetchPage(productId, 1).then((firstPage) => {
      const total = Math.max(0, Number(firstPage.number_of_reviews || 0));
      const pageCount = Math.max(1, Math.ceil(total / 100));
      const remaining = [];
      for (let page = 2; page <= pageCount; page += 1) remaining.push(fetchPage(productId, page));
      return Promise.all(remaining).then((pages) => ({
        total,
        average: Number(firstPage.average_rating || 0),
        reviews: [firstPage, ...pages].flatMap((data) => Array.isArray(data.reviews) ? data.reviews : [])
      }));
    });

    Promise.all(productIds.map(fetchProductReviews))
      .then((groups) => {
        const uniqueReviews = new Map();
        groups.flatMap((group) => group.reviews).forEach((review) => {
          const key = review.uuid || [review.product_url, review.created_at, review.reviewer_name, review.body_html].join('|');
          if (!uniqueReviews.has(key)) uniqueReviews.set(key, review);
        });
        const reviews = Array.from(uniqueReviews.values()).sort((a, b) => {
          return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
        });
        if (!reviews.length) throw new Error('No Judge.me reviews');

        let rendered = 0;
        const renderNext = () => {
          reviews.slice(rendered, rendered + 20).forEach((review) => grid.append(renderReview(review)));
          rendered = Math.min(rendered + 20, reviews.length);
          if (moreButton) {
            moreButton.hidden = rendered >= reviews.length;
            moreButton.textContent = rendered >= reviews.length
              ? 'Toate recenziile sunt afișate'
              : `Arată mai multe recenzii (${reviews.length - rendered})`;
          }
          if (actions) actions.hidden = rendered >= reviews.length;
        };
        renderNext();
        moreButton?.addEventListener('click', renderNext);

        const totalReviews = groups.reduce((sum, group) => sum + group.total, 0);
        const weightedRating = groups.reduce((sum, group) => sum + group.average * group.total, 0);
        const averageRating = totalReviews ? weightedRating / totalReviews : 0;
        if (status) status.hidden = true;
        if (summary) {
          summary.hidden = false;
          summary.querySelector('[data-as-review-average]').textContent = averageRating.toLocaleString('ro-RO', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
          summary.querySelector('[data-as-review-total]').textContent = totalReviews || reviews.length;
        }

        const officialWidget = document.querySelector('.jdgm-review-widget');
        const officialSection = officialWidget?.closest('.shopify-section');
        if (officialSection) officialSection.hidden = true;
      })
      .catch(() => {
        if (status) status.textContent = 'Recenziile se încarcă în widgetul Judge.me de mai jos.';
      });
  };

  const translateJudgeMeText = (value) => {
    if (!value) return value;

    return value
      .replace(/Sort reviews by/gi, 'Sortează recenziile după')
      .replace(/No reviews/gi, 'Fără recenzii')
      .replace(/Go to previous page/gi, 'Pagina anterioară')
      .replace(/Go to next page/gi, 'Pagina următoare')
      .replace(/Go to page (\d+)/gi, 'Mergi la pagina $1')
      .replace(/View reviews on the Reviews Site/gi, 'Vezi toate recenziile')
      .replace(/Thumbnail Navigation/gi, 'Navigare miniaturi')
      .replace(/\breviews\b/gi, 'recenzii')
      .replace(/\breview\b/gi, 'recenzie');
  };

  const localizeJudgeMe = () => {
    const containers = document.querySelectorAll([
      '.jdgm-review-widget',
      '.jdgm-prev-badge',
      '.as-product-card__rating',
      '.asb-flavor-card__rating'
    ].join(','));

    containers.forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        const parentTag = textNode.parentElement?.tagName;
        if (parentTag !== 'SCRIPT' && parentTag !== 'STYLE') {
          const translated = translateJudgeMeText(textNode.nodeValue);
          if (translated !== textNode.nodeValue) textNode.nodeValue = translated;
        }
        textNode = walker.nextNode();
      }

      container.querySelectorAll('[aria-label], [title]').forEach((element) => {
        ['aria-label', 'title'].forEach((attribute) => {
          const current = element.getAttribute(attribute);
          const translated = translateJudgeMeText(current);
          if (current && translated !== current) element.setAttribute(attribute, translated);
        });
      });
    });
  };

  let judgeMeLocalizationQueued = false;
  const queueJudgeMeLocalization = () => {
    if (judgeMeLocalizationQueued) return;
    judgeMeLocalizationQueued = true;
    window.requestAnimationFrame(() => {
      judgeMeLocalizationQueued = false;
      localizeJudgeMe();
    });
  };

  const observeJudgeMe = () => {
    queueJudgeMeLocalization();
    const observer = new MutationObserver(queueJudgeMeLocalization);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-as-collection]').forEach(initCollection);
    scope.querySelectorAll('[data-as-product]').forEach(initProduct);
    scope.querySelectorAll('[data-as-judge-reviews]').forEach(initJudgeMeReviews);
  };

  document.addEventListener('DOMContentLoaded', () => {
    boot();
    observeJudgeMe();
  });
  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
    queueJudgeMeLocalization();
  });
})();
